import { useEffect,useState } from "react";

import { Space,Spin,Table } from "antd";
import {
  CategoryScale,
  Chart as ChartJS,
  Tooltip as ChartTooltip,
  Legend,
  LinearScale,
  LineElement,
  PointElement,
  Title
} from "chart.js";
import { Line } from "react-chartjs-2";
import Breadcrumbs from "../../../../components/Breadcrumbs";
import AllSalaryAddPopup from "../../../../components/modelpopup/AllSalaryAddPopup";
import DeleteModal from "../../../../components/modelpopup/DeleteModal";


import { getEmployeePayrollApi,getEmployeePayrollDownloadApi } from "api/services/employee";
import { Button } from "components/Button";
import SalaryFilter from "components/Drawer/salaryFilterDrawer";
import { SkeltonLoader } from "components/skeltonLoader";
import { Bounce,toast } from "react-toastify";
import { formatDateHandler3 } from "utils/common";
import { useSalary } from "../context/salaryContext";

// Add ChartDataLabels plugin
import ChartDataLabels from 'chartjs-plugin-datalabels';

// Register Chart.js components
ChartJS.register(
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  ChartTooltip,
  Legend,
  ChartDataLabels  // Add this
);

const AllSalary = () => {
  const {
    searchText,
    view,
    setView,
    salaryModal,
    setSalaryModal,
    pageSettings,
    handleGridChange,
    handleChange,
    handleSearchChange,
    handleFilterDrawer,
    showFilterDrawer,

    handleFilterChange,
    filters,
    handleInputChange,
    handleApplyFilter,
    filterLoading,
    
    handleSalaryDetailPage,
    handleDateChange
  } = useSalary();
  const [chartData, setChartData] = useState({
    labels: [
      "Jan", "Feb", "Mar", "Apr", "May", "Jun",
      "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"
    ],
    datasets: [
      {
        label: "Basic Salary",
        data: [],
        borderColor: "#667eea",
        backgroundColor: (context) => {
          const ctx = context.chart.ctx;
          const gradient = ctx.createLinearGradient(0, 0, 0, 400);
          gradient.addColorStop(0, "rgba(102, 126, 234, 0.3)");
          gradient.addColorStop(1, "rgba(102, 126, 234, 0.05)");
          return gradient;
        },
        tension: 0.5,
        borderWidth: 3,
        pointRadius: 5,
        pointHoverRadius: 8,
        pointBackgroundColor: "#fff",
        pointBorderColor: "#667eea",
        pointBorderWidth: 3,
        pointHoverBorderWidth: 4,
        fill: true,
        shadowOffsetX: 0,
        shadowOffsetY: 4,
        shadowBlur: 10,
        shadowColor: "rgba(102, 126, 234, 0.3)",
        datalabels: {
          color: '#667eea',
          font: {
            weight: '600'
          }
        }
      },
      {
        label: "Transportation Allowance",
        data: [],
        borderColor: "#f59e0b",
        backgroundColor: (context) => {
          const ctx = context.chart.ctx;
          const gradient = ctx.createLinearGradient(0, 0, 0, 400);
          gradient.addColorStop(0, "rgba(245, 158, 11, 0.3)");
          gradient.addColorStop(1, "rgba(245, 158, 11, 0.05)");
          return gradient;
        },
        tension: 0.5,
        borderWidth: 3,
        pointRadius: 5,
        pointHoverRadius: 8,
        pointBackgroundColor: "#fff",
        pointBorderColor: "#f59e0b",
        pointBorderWidth: 3,
        pointHoverBorderWidth: 4,
        fill: true,
        shadowOffsetX: 0,
        shadowOffsetY: 4,
        shadowBlur: 10,
        shadowColor: "rgba(245, 158, 11, 0.3)",
        datalabels: {
          color: '#f59e0b',
          font: {
            weight: '600'
          }
        }
      },
      {
        label: "Accommodation Allowance",
        data: [],
        borderColor: "#10b981",
        backgroundColor: (context) => {
          const ctx = context.chart.ctx;
          const gradient = ctx.createLinearGradient(0, 0, 0, 400);
          gradient.addColorStop(0, "rgba(16, 185, 129, 0.3)");
          gradient.addColorStop(1, "rgba(16, 185, 129, 0.05)");
          return gradient;
        },
        tension: 0.5,
        borderWidth: 3,
        pointRadius: 5,
        pointHoverRadius: 8,
        pointBackgroundColor: "#fff",
        pointBorderColor: "#10b981",
        pointBorderWidth: 3,
        pointHoverBorderWidth: 4,
        fill: true,
        shadowOffsetX: 0,
        shadowOffsetY: 4,
        shadowBlur: 10,
        shadowColor: "rgba(16, 185, 129, 0.3)",
        datalabels: {
          color: '#10b981',
          font: {
            weight: '600'
          }
        }
      }
    ]
  });

  const chartOptions = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      legend: {
        position: 'bottom',
        align: 'center',
        labels: {
          usePointStyle: true,
          padding: 15,
          boxWidth: 10,
          boxHeight: 10,
          font: {
            size: 12,
            weight: '500',
            family: "'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif"
          },
          color: '#333',
          generateLabels: (chart) => {
            const original = ChartJS.defaults.plugins.legend.labels.generateLabels;
            const labels = original(chart);
            labels.forEach((label) => {
              label.fillStyle = label.strokeStyle;
            });
            return labels;
          }
        }
      },
      tooltip: {
        mode: 'index',
        intersect: false,
        backgroundColor: 'rgba(255, 255, 255, 0.98)',
        titleColor: '#1f2937',
        bodyColor: '#4b5563',
        borderColor: 'rgba(0, 0, 0, 0.08)',
        borderWidth: 1,
        padding: 16,
        displayColors: true,
        boxWidth: 12,
        boxHeight: 12,
        usePointStyle: true,
        cornerRadius: 8,
        titleFont: {
          size: 14,
          weight: '600',
          family: "'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif"
        },
        bodyFont: {
          size: 13,
          weight: '500',
          family: "'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif"
        },
        callbacks: {
          label: function(context) {
            let label = context.dataset.label || '';
            if (label) {
              label += ': ';
            }
            if (context.parsed.y !== null) {
              label += new Intl.NumberFormat('en-US', {
                style: 'currency',
                currency: 'AED',
                maximumFractionDigits: 0
              }).format(context.parsed.y);
            }
            return label;
          },
          title: function(context) {
            return `Month: ${context[0].label}`;
          }
        }
      },
      datalabels: {
        display: false,
        align: 'top',
        anchor: 'end',
        offset: 6,
        formatter: function(value) {
          if (value === 0 || value === null) return '';
          return new Intl.NumberFormat('en-US', {
            notation: 'compact',
            maximumFractionDigits: 1
          }).format(value);
        },
        font: {
          size: 10,
          weight: '600',
          family: "'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif"
        },
        color: '#1f2937',
        backgroundColor: 'rgba(255, 255, 255, 0.9)',
        padding: {
          top: 4,
          bottom: 4,
          left: 6,
          right: 6
        },
        borderRadius: 6,
        borderWidth: 1,
        borderColor: 'rgba(0, 0, 0, 0.08)'
      }
    },
    interaction: {
      mode: 'nearest',
      axis: 'x',
      intersect: false
    },
    scales: {
      x: {
        grid: {
          display: false,
          drawBorder: false
        },
        border: {
          display: true,
          color: '#e5e7eb',
          width: 1
        },
        title: {
          display: true,
          text: 'Month',
          font: {
            size: 13,
            weight: '600',
            family: "'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif"
          },
          color: '#6b7280',
          padding: { top: 12, bottom: 0 }
        },
        ticks: {
          font: {
            size: 12,
            weight: '500',
            family: "'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif"
          },
          color: '#6b7280',
          padding: 8
        }
      },
      y: {
        grid: {
          color: 'rgba(0, 0, 0, 0.04)',
          drawBorder: false,
          lineWidth: 1
        },
        border: {
          display: true,
          color: '#e5e7eb',
          width: 1
        },
        title: {
          display: true,
          text: 'Amount (AED)',
          font: {
            size: 13,
            weight: '600',
            family: "'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif"
          },
          color: '#6b7280',
          padding: { bottom: 12, top: 0 }
        },
        ticks: {
          font: {
            size: 12,
            weight: '500',
            family: "'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif"
          },
          color: '#6b7280',
          callback: function(value) {
            return new Intl.NumberFormat('en-US', {
              style: 'currency',
              currency: 'AED',
              maximumFractionDigits: 0,
              notation: 'compact'
            }).format(value);
          },
          padding: 10,
          maxTicksLimit: 8
        },
        beginAtZero: false
      }
    },
    elements: {
      line: {
        tension: 0.5,
        borderCapStyle: 'round',
        borderJoinStyle: 'round'
      },
      point: {
        radius: 5,
        hoverRadius: 8,
        borderWidth: 3,
        hoverBorderWidth: 4,
        hoverBackgroundColor: '#fff'
      }
    },
    animation: {
      duration: 1000,
      easing: 'easeInOutQuart'
    }
  };

  const [selectedRow, setSelectedRow] = useState([]);
  





  const [expandedRows, setExpandedRows] = useState([]);
  const [loadingRow, setLoadingRow] = useState(null); 
  const [salaryDetails, setSalaryDetails] = useState({});

  const[payrollData, setPayrollData] = useState([])
  const[loading, setLoading] = useState(false)
  const CURRENT_YEAR = new Date().getFullYear();
  const[selectedYear, setSelectedYear] = useState(() => CURRENT_YEAR) // Default to current year
  const[exportLoading, setExportLoading] = useState(false)
  
  useEffect(()=>{
    getPayrollData()
  },[selectedYear]) // Add selectedYear as dependency
 
  const getPayrollData = () => {
    setLoading(true)
    let filters = {
      year: selectedYear
    }
    getEmployeePayrollApi(filters).then(response=>{
      console.log(response.data, " DATAAAAA")
      setPayrollData(response.data)
      setLoading(false)
    })
  }
  
  // Year selection handler
  const handleYearChange = (value) => {
    setSelectedYear(value);
  }
  
  // Generate year options from 2025 to current year
  const yearOptions = [];
  // Start from 2025 and only include years up to the current year
  for (let year = 2025; year <= CURRENT_YEAR; year++) {
    yearOptions.push({ value: year, label: year.toString() });
  }

  useEffect(() => {
    if (payrollData.length) {
      const basicPayList = [];
      const travelList = [];
      const accList = [];

      payrollData.forEach(item => {
        basicPayList.push(item['Basic Salary']);
        travelList.push(item['Transportation Allowance']);
        accList.push(item['Accomodation Allowance']);
      });

      setChartData(prevData => ({
        ...prevData,
        datasets: [
          {
            ...prevData.datasets[0],
            data: basicPayList
          },
          {
            ...prevData.datasets[1],
            data: travelList
          },
          {
            ...prevData.datasets[2],
            data: accList
          }
        ]
      }));
    }
  }, [payrollData]);



  
  


  const columns = [
    // {
    //   title: "Emp No",
    //   dataIndex: "id",
    //   render: (text, record) => (
    //     <span className="table-avatar">
    //       {record.company_user.emp_no}
    //     </span>
    //   )  ,
    //    sorter: (a, b) => b.salary.id - a.salary.id,
    // },
    {
      title: "Payroll Period",
      dataIndex: "class_code",
      render: (text, record, index) => (
        <h2 className="table-avatar d-flex align-items-center">
      
              {
                formatDateHandler3(record?.start_date)
              }

        </h2>
      ),
    },
    
  
    {
      title: "Basic Salary",
      dataIndex: "basic_pay",
      sorter: false,
      render: (text, record) => {
  
          return(
            <span className="table-avatar">
              {record['Basic Salary']}
            </span>
          )
        
        
        },
      align:"center"
    
    },
  
    {
      title: "Accommodation Allowance",
      dataIndex: "name",
      sorter: false,
      render: (text, record) => {
          return(
            <span className="table-avatar">
              {record['Accomodation Allowance']}
            </span>
          )
      
       }  
    
    },
  
  
    {
      title: "Transportation Allowance",
      dataIndex: "transport_allowance",
      render: (text, record) => {
          return(
            <span className="table-avatar">
              {record['Transportation Allowance']}
            </span>
          )
        
       }  
    }, 
    {
      title: "Total Salary",
      dataIndex: "total_salary",
      sorter: false,
      render: (text, record) => {
       
          return(
            <span className="table-avatar">
              {record['Total Salary']}
            </span>
          )
        }
           
    
    },
    // {
    //   title: "Leave Accrual",
    //   dataIndex: "leave_accrual",
    //   sorter: true,
    //   render: (text, record) => {
       
    //     return(
    //       <span className="table-avatar">
    //         {record['Annual Leave Accrual']}
    //       </span>
    //     )
    //   }   
    
    // },
    {
      title: "Gross Salary",
      dataIndex: "gross_salary",
      sorter: false,
      render: (text, record) => (
        <span className="table-avatar">
          {/* {record.company_user.email} */}
          {record['Net Salary']}
        </span>
      )   
    
    },
    {
      title: "Total Deduction",
      dataIndex: "total_deductions",
      sorter: false,
      render: (text, record) => (
        <span className="table-avatar">
          {/* {record.company_user.email} */}
          {record['Total Deduction']}
        </span>
      )   
    
    },
    {
      title: "Net Pay",
      dataIndex: "net_pay",
      sorter: false,
      render: (text, record) => (
        <span className="table-avatar">
          {/* {record.company_user.email} */}
          {record['Net Salary']}
        </span>
      )   
    
    },
    // {
    //   title: "Comments",
    //   dataIndex: "comments",
    //   sorter: true,
    //   render: (text, record) => (
    //     <span className="table-avatar">

    //     </span>
    //   )   
    
    // },
    // {
    //   title: "Status",
    //   dataIndex: "status",
    //   sorter: false,
    //   render: (text, record) => (
    //     <span className="table-avatar">
    //       <span className="badge badge-primary" >{record.Status}</span>
    //       {/* {record.company_user.email} */}
    //     </span>
    //   )   
    
    // },
  ];



  const handleDownload = (type) => {
    let params = {
      type: type,
      year: selectedYear,
      month: selectedRow.map(item=> item.split("-")[1]).join(",")
    }
    setExportLoading(true)
    // For PDF downloads, we need to specify responseType as blob
    getEmployeePayrollDownloadApi(params, { responseType: 'blob' })
      .then(response => {
        console.log(response, " RESPONSE")
        if (type === "export") {
          // Create a blob from the PDF response
          const blob = new Blob([response.data], { type: 'application/pdf' });
          
          // Create an object URL from the blob
          const url = window.URL.createObjectURL(blob);
          
          // Create a temporary anchor element for download
          const link = document.createElement('a');
          link.href = url;
          
          // Set filename with year and timestamp
          const timestamp = new Date().getTime();
          link.download = `payroll-${selectedYear}-${timestamp}.pdf`;
          
          // Append to body, trigger download, and clean up
          document.body.appendChild(link);
          link.click();
          
          // Clean up
          setTimeout(() => {
            document.body.removeChild(link);
            window.URL.revokeObjectURL(url);
          }, 100);
        } else {
          toast.success('Email sent successfully', {
            position: "top-right",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: false,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "light",
            transition: Bounce,
            });
          
        }
        setExportLoading(false)
      })

      .catch(error => {
         
          toast.error(`${type == "export" ? "Download" : "Email"} failed: ` + (error.response?.data?.error || "Unknown error"), {
            position: "top-right",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: false,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "light",
            transition: Bounce,
          });
          setExportLoading(false)
        console.log(error, " ERROR")
      });
  }
  const GridView = () => {
    if (loading) {
      return (
        <SkeltonLoader
          style={{height:200}}
          number={2}
          active={true}
          className="col-12 mb-2"
        />
      );
    } else {
      return (
        <>
          {payrollData.map((salary, index) => (
            <div
              className="col-md-6 col-sm-12 col-12 col-lg-3 col-xl-4"
              key={salary.id}
            >
              <div className={`profile-widget ${selectedRow.includes(salary.end_date) ? 'bg-light-info' : ''}`}>
                <div className="col-12">
                  <div className="d-flex justify-content-between align-items-start mb-2">
                    <div className="form-check">
                      <input
                        className="form-check-input"
                        type="checkbox"
                        checked={selectedRow.includes(salary.end_date)}
                        onChange={(e) => {
                          if (e.target.checked) {
                            setSelectedRow(prev => [...prev, salary.end_date]);
                          } else {
                            setSelectedRow(prev => prev.filter(item => item !== salary.end_date));
                          }
                        }}
                        id={`checkbox-${salary.start_date}`}
                      />
                    </div>
                    <h4 className="user-name m-0 text-ellipsis text-start">
                      <a>{formatDateHandler3(salary?.start_date)}</a>
                    </h4>
                  </div>

                  <h5 className="user-name m-t-10 mb-0 text-ellipsis text-start">
                    <a>Total Salary : {salary['Total Salary']}</a>
                  </h5>
                  <div className="m-t-10 small text-muted text-start">Basic Salary : {salary['Basic Salary']}</div>
                  <div className="m-t-10 small text-muted text-start">Accommodation Allowance : {salary['Accomodation Allowance']}</div>
                  <div className="m-t-10 small text-muted text-start">Transportation Allowance : {salary['Transportation Allowance']}</div>
                </div>
              </div>
            </div>
          ))}
        </>
      );
    }
  };

  const rowSelection = {
    onChange: (selectedRowKeys, selected) => {
      setSelectedRow(selected.map(item=> item.end_date))
      console.log(`selectedRowKeys: ${selectedRowKeys}`, 'selectedRows: ', selectedRow);
    },
    getCheckboxProps: (record) => ({
      // disabled: record.name === 'Disabled User',
      // Column configuration not to be checked
      name: record.start_date,
    }),
  };

  return (
    <div>
      <div className="page-wrapper">
        <div className="content container-fluid">
          <Breadcrumbs
            maintitle="Payroll"
            title="Dashboard"
            subtitle="Payroll"
            modal="#add_salary"
            name="Add Salary"          
            view={view}
            setSalaryModal={setSalaryModal}
            setView={setView}
          />

          {/* Year Dropdown */}
          <div className="row mb-4">
            <div className="col-12">
              <div className="card" style={{ 
                borderRadius: "20px", 
                border: "none",
                background: "linear-gradient(135deg, #D3001A 0%, #f59e0b 50%, #fbbf24 100%)",
                overflow: "hidden",
                position: "relative",
                boxShadow: "0 8px 32px rgba(211, 0, 26, 0.25), 0 4px 16px rgba(245, 158, 11, 0.15)"
              }}>
                {/* Enhanced decorative elements */}
                <div style={{
                  position: "absolute",
                  top: "-60px",
                  right: "-60px",
                  width: "240px",
                  height: "240px",
                  borderRadius: "50%",
                  background: "rgba(255, 255, 255, 0.12)",
                  zIndex: 0,
                  filter: "blur(20px)"
                }}></div>
                <div style={{
                  position: "absolute",
                  bottom: "-40px",
                  left: "-40px",
                  width: "180px",
                  height: "180px",
                  borderRadius: "50%",
                  background: "rgba(255, 255, 255, 0.1)",
                  zIndex: 0,
                  filter: "blur(20px)"
                }}></div>
                <div style={{
                  position: "absolute",
                  top: "50%",
                  right: "10%",
                  width: "100px",
                  height: "100px",
                  borderRadius: "50%",
                  background: "rgba(255, 255, 255, 0.08)",
                  zIndex: 0,
                  filter: "blur(15px)",
                  transform: "translateY(-50%)"
                }}></div>
                <div className="card-body p-4 p-md-5" style={{ position: "relative", zIndex: 1 }}>
                  <div className="d-flex flex-column flex-md-row align-items-start align-items-md-center justify-content-between gap-3">
                    <div className="d-flex align-items-center flex-grow-1">
                      <div style={{
                        width: "64px",
                        height: "64px",
                        borderRadius: "16px",
                        background: "rgba(255, 255, 255, 0.25)",
                        backdropFilter: "blur(12px)",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        marginRight: "20px",
                        boxShadow: "0 8px 24px rgba(0, 0, 0, 0.15), inset 0 1px 0 rgba(255, 255, 255, 0.3)",
                        border: "1px solid rgba(255, 255, 255, 0.2)",
                        transition: "all 0.3s ease"
                      }}
                      onMouseEnter={(e) => {
                        e.currentTarget.style.transform = "scale(1.05)";
                        e.currentTarget.style.boxShadow = "0 12px 32px rgba(0, 0, 0, 0.2), inset 0 1px 0 rgba(255, 255, 255, 0.4)";
                      }}
                      onMouseLeave={(e) => {
                        e.currentTarget.style.transform = "scale(1)";
                        e.currentTarget.style.boxShadow = "0 8px 24px rgba(0, 0, 0, 0.15), inset 0 1px 0 rgba(255, 255, 255, 0.3)";
                      }}
                      >
                        <i className="las la-calendar-alt" style={{ fontSize: "32px", color: "#fff" }}></i>
                      </div>
                      <div>
                        <h5 className="mb-2" style={{ fontSize: "20px", fontWeight: "700", color: "#fff", margin: 0, letterSpacing: "-0.02em" }}>Select Year</h5>
                        <p className="mb-0" style={{ fontSize: "14px", color: "rgba(255, 255, 255, 0.95)", margin: 0, fontWeight: "400" }}>Choose the year to view payroll data</p>
                      </div>
                    </div>
                    <div style={{ 
                      width: '200px',
                      minWidth: '200px',
                      position: "relative"
                    }}>
                      <select 
                        className="form-control form-select" 
                        value={selectedYear}
                        onChange={(e) => {
                          setSelectedRow([])
                          handleYearChange(parseInt(e.target.value))}}
                        style={{ 
                          borderRadius: "14px", 
                          border: "none",
                          background: "rgba(255, 255, 255, 0.98)",
                          padding: "14px 48px 14px 18px",
                          fontSize: "16px",
                          fontWeight: "600",
                          color: "#1f2937",
                          boxShadow: "0 6px 20px rgba(0, 0, 0, 0.15), 0 2px 8px rgba(0, 0, 0, 0.1)",
                          cursor: "pointer",
                          appearance: "none",
                          backgroundImage: `url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='14' height='14' viewBox='0 0 14 14'%3E%3Cpath fill='%23D3001A' d='M7 10L2 5h10z'/%3E%3C/svg%3E")`,
                          backgroundRepeat: "no-repeat",
                          backgroundPosition: "right 18px center",
                          lineHeight: "1.5",
                          minHeight: "52px",
                          height: "52px",
                          transition: "all 0.3s ease"
                        }}
                        onMouseEnter={(e) => {
                          e.target.style.boxShadow = "0 8px 24px rgba(0, 0, 0, 0.2), 0 4px 12px rgba(0, 0, 0, 0.15)";
                          e.target.style.transform = "translateY(-2px)";
                        }}
                        onMouseLeave={(e) => {
                          e.target.style.boxShadow = "0 6px 20px rgba(0, 0, 0, 0.15), 0 2px 8px rgba(0, 0, 0, 0.1)";
                          e.target.style.transform = "translateY(0)";
                        }}
                      >
                        {yearOptions.map(option => (
                          <option key={option.value} value={option.value} style={{ padding: "10px", fontSize: "15px" }}>
                            {option.label}
                          </option>
                        ))}
                      </select>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* <SalaryListFilter
           filters={filters} 
           handleInputChange={handleInputChange} 
           searchPlaceholder={"Search Data"} 
           handleFilterDrawer={handleFilterDrawer}
            handleFilterChange={handleFilterChange}
            loading={loading}
          /> */}



          {/* {view == "grid" ? (
            <div className="row">    
              <GridView />
              <div className="my-2 d-flex justify-content-end ">
                <div className="col-sm-12 col-md-6 ">
                  <Pagination
                    pageSize={pageSettings?.pageSize}
                    pageSizeOptions={pageSizeOptions}
                    defaultCurrent={1}
                    current={pageSettings?.page}
                    total={pageSettings?.total}
                    itemRender={itemRender}
                    onChange={handleGridChange}
                  />
                </div>
              </div>
            </div>
          ) : ( */}
          <div className="col-md-12 mb-4">
            <div className="card" style={{ 
              borderRadius: "20px", 
              border: "none",
              background: "linear-gradient(to bottom, #ffffff 0%, #fef2f2 100%)",
              overflow: "hidden",
              position: "relative",
              boxShadow: "0 8px 32px rgba(211, 0, 26, 0.12), 0 4px 16px rgba(245, 158, 11, 0.08)"
            }}>
              {/* Decorative background elements */}
              <div style={{
                position: "absolute",
                top: "-40px",
                right: "-40px",
                width: "160px",
                height: "160px",
                borderRadius: "50%",
                background: "linear-gradient(135deg, rgba(211, 0, 26, 0.08) 0%, rgba(245, 158, 11, 0.06) 100%)",
                zIndex: 0,
                filter: "blur(20px)"
              }}></div>
              <div style={{
                position: "absolute",
                bottom: "-30px",
                left: "-30px",
                width: "120px",
                height: "120px",
                borderRadius: "50%",
                background: "linear-gradient(135deg, rgba(251, 191, 36, 0.08) 0%, rgba(211, 0, 26, 0.05) 100%)",
                zIndex: 0,
                filter: "blur(20px)"
              }}></div>
              
              <div className="card-body p-4" style={{ position: "relative", zIndex: 1 }}>
                <div className="d-flex justify-content-between align-items-center mb-4">
                  <div className="d-flex align-items-center flex-grow-1">
                    <div style={{
                      width: "56px",
                      height: "56px",
                      borderRadius: "14px",
                      background: "linear-gradient(135deg, #D3001A 0%, #f59e0b 50%, #fbbf24 100%)",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      marginRight: "16px",
                      boxShadow: "0 6px 20px rgba(211, 0, 26, 0.25), 0 2px 8px rgba(245, 158, 11, 0.15)",
                      transition: "all 0.3s ease"
                    }}
                    onMouseEnter={(e) => {
                      e.currentTarget.style.transform = "scale(1.05) rotate(5deg)";
                      e.currentTarget.style.boxShadow = "0 8px 28px rgba(211, 0, 26, 0.35), 0 4px 12px rgba(245, 158, 11, 0.2)";
                    }}
                    onMouseLeave={(e) => {
                      e.currentTarget.style.transform = "scale(1) rotate(0deg)";
                      e.currentTarget.style.boxShadow = "0 6px 20px rgba(211, 0, 26, 0.25), 0 2px 8px rgba(245, 158, 11, 0.15)";
                    }}
                    >
                      <i className="las la-chart-line" style={{ fontSize: "26px", color: "#fff" }}></i>
                    </div>
                    <div>
                      <h5 className="card-title mb-1" style={{ fontSize: "20px", fontWeight: "700", color: "#1f2937", margin: 0, letterSpacing: "-0.02em" }}>Payroll Statistics</h5>
                      <p className="text-muted mb-0" style={{ fontSize: "13px", color: "#6b7280", fontWeight: "400" }}>Monthly breakdown of salary components</p>
                    </div>
                  </div>
                </div>
                <div style={{ height: "350px", padding: "10px 0 15px 0", position: "relative" }}>
                  {loading ? (
                    <div style={{
                      position: "absolute",
                      top: 0,
                      left: 0,
                      right: 0,
                      bottom: 0,
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      background: "rgba(255, 255, 255, 0.95)",
                      borderRadius: "12px",
                      zIndex: 10,
                      backdropFilter: "blur(4px)"
                    }}>
                      <Spin size="large" />
                    </div>
                  ) : (
                    <Line 
                      data={chartData} 
                      options={chartOptions}
                      plugins={[ChartDataLabels]}
                    />
                  )}
                </div>
              </div>
            </div>
          </div>
          {
            selectedRow?.length>0 && 
            <div className="row mb-3">
              <div className="col-12">
                <Space>
                  <Button 
                    disabled={exportLoading} 
                    loading={exportLoading} 
                    onClick={()=>handleDownload("export")} 
                    className="btn btn-primary shadow-sm" 
                    label="Download" 
                    style={{ borderRadius: "8px" }}
                  />
                  <Button 
                    disabled={exportLoading} 
                    loading={exportLoading} 
                    onClick={()=>handleDownload("email")} 
                    className="btn btn-primary shadow-sm"  
                    label="Send as mail"
                    style={{ borderRadius: "8px" }}
                  />
                </Space>
              </div>
            </div>
          }
         

            <div className="row">
            {view == "grid" ? (
                <div className="row">    
              <GridView />
              {/* <div className="my-2 d-flex justify-content-end ">
                <div className="col-sm-12 col-md-6 ">
                <Pagination
                    pageSize={pageSettings?.pageSize}
                    pageSizeOptions={pageSizeOptions}
                    defaultCurrent={1}
                    current={pageSettings?.page}
                    total={pageSettings?.total}
                    // itemRender={itemRender}
                    onChange={handleGridChange}
                    showLessItems
                    showSizeChanger={false}
                    showQuickJumper={false}
                    hideOnSinglePage
                    itemRender={(page, type, originalElement) => {
                      if (type === "next") {
                        return (
                          <Button
                            loading={loading}
                            // disabled={loading || (selectedLeavePlanner && selectedLeavePlanner?.leave_planner?.company_user?.id != user?.id)}
                            className="btn btn-primary "
                            // type="Load More"
                            label="Load More"
                          />
                        );
                      }
                      return null;
                    }}
                  />
                </div>
              </div> */}
            </div>
            )
            :
            <div className="col-12">
              <div className="card shadow-sm" style={{ borderRadius: "12px", border: "1px solid #e0e0e0", overflow: "hidden" }}>
                <style>{`
                  .modern-table .ant-table-tbody > tr { background-color: #ffffff !important; }
                  .modern-table .ant-table-tbody > tr:hover > td { background-color: #f5f5f5 !important; }
                  .modern-table .ant-table-thead > tr > th {
                    background-color: #f8f9fa !important; font-weight: 600; color: #333;
                    border-bottom: 2px solid #e0e0e0; padding: 10px 12px; font-size: 13px;
                  }
                  .modern-table .ant-table-tbody > tr > td {
                    border-bottom: 1px solid #f0f0f0; padding: 10px 12px; font-size: 13px;
                  }
                  .modern-table .ant-table-wrapper .ant-table-pagination.ant-pagination {
                    border-top: 1px solid #f0f0f0; background-color: #ffffff;
                    border-bottom-left-radius: 12px; border-bottom-right-radius: 12px;
                  }
                `}</style>
                <div className="table-responsive" style={{ overflowX: "auto" }}>
                  <Table
                    className="mb-0 modern-table"
                    style={{ borderRadius: "12px", minWidth: "100%" }}
                    scroll={{ x: "max-content" }}
                    columns={columns}
                    dataSource={payrollData}
                    rowKey={(record) => record.start_date}
                    loading={loading}
                    pagination={false}
                    rowSelection={{
                      type: "checkbox",
                      ...rowSelection,
                    }}
                  />
                </div>
              </div>
            </div>
          }

             
            </div>
           {/* )} */}
        </div>
      </div>

      <AllSalaryAddPopup />
      {/* Delete Modal */}
      <DeleteModal Name="Delete Salary" />

      <SalaryFilter
          searchPlaceholder={"Search Salary"}
          showFilterDrawer={showFilterDrawer}
          handleFilterDrawer={handleFilterDrawer}

          handleFilterChange={handleFilterChange}
          filters={filters}
          handleInputChange={handleInputChange}
          handleApplyFilter={handleApplyFilter}
          filterLoading={filterLoading}
          handleDateChange={handleDateChange}
/>
      {/* Delete Modal */}
    </div>
  );
};

export default AllSalary;
